import { toast } from 'react-toastify'
import {
  all, call, put, select, takeLatest,
} from 'redux-saga/effects'
import { actions as appActions } from '../state'
import apis from './StockListApi'
import { selectFilters, selectPage } from './StockListSelector'
import { actions } from './StockListState'

export function* getStock() {
  yield put(appActions.isLoading(true))

  try {
    const {
      fulfillmentCenterId, modelId, code, barcode, description,
    } = yield select(selectFilters)
    const page = yield select(selectPage)

    const { data: products, totalItems } = yield call(
      apis.getStockProducts,
      {
        fulfillmentCenterId,
        modelId,
        code,
        barcode,
        page,
        pageSize: 100,
        description,
      },
    )
    yield put(actions.setTotalItems(totalItems))
    yield put(actions.addStock(products))
  } catch (error: any) {
    toast.error(`Ocorreu um erro: ${error?.response?.data?.message ?? error.message}`)
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export default function* () {
  yield all([
    takeLatest(actions.getStock.type, getStock),
  ])
}
